<template>
    <div class="navigation-panel">

        <nav role="menu" id="menu" class="items">
            <ul>

                <li>
                    <a
                    v-on:click="closeNavPanel()"
                    v-link="{ name: 'view' }"
                    role="menuitem"
                    v-bind:aria-hidden="[ isNavMenuOpened && !isHotspotPanelOpened ? 'false' : 'true'  ]"
                    v-bind:tabindex="[ isNavMenuOpened && !isHotspotPanelOpened ? '0' : '-1'  ]">
                        View<span class="hide-for-mobile"> Graham</span>
                    </a>
                </li>
                <li>
                    <a
                    v-on:click="closeNavPanel()"
                    v-link="{ name: 'about' }"
                    role="menuitem"
                    v-bind:aria-hidden="[ isNavMenuOpened && !isHotspotPanelOpened ? 'false' : 'true'  ]"
                    v-bind:tabindex="[ isNavMenuOpened && !isHotspotPanelOpened ? '0' : '-1'  ]">
                        About<span class="hide-for-mobile"> the project</span>
                    </a>
                </li>
                <li>
                    <a
                    v-on:click="closeNavPanel()"
                    v-link="{ name: 'context' }"
                    role="menuitem"
                    v-bind:aria-hidden="[ isNavMenuOpened && !isHotspotPanelOpened ? 'false' : 'true'  ]"
                    v-bind:tabindex="[ isNavMenuOpened && !isHotspotPanelOpened ? '0' : '-1'  ]">
                        <span class="hide-for-mobile">The Broader </span>Context
                    </a>
                </li>
                <li>
                    <a
                    v-on:click="closeNavPanel()"
                    v-link="{ name: 'educational' }"
                    role="menuitem"
                    v-bind:aria-hidden="[ isNavMenuOpened && !isHotspotPanelOpened ? 'false' : 'true'  ]"
                    v-bind:tabindex="[ isNavMenuOpened && !isHotspotPanelOpened ? '0' : '-1'  ]">
                        Education<span class="hide-for-mobile">al Experience</span>
                    </a>
                </li>
            </ul>
        </nav>

    </div>
</template>

<script>
    import { closeNavMenu, closeNavMenuDelay } from '../vuex/actions'

    export default {
        vuex: {
            getters: {
                isNavMenuOpened: state => state.isNavMenuOpened,
                isHotspotPanelOpened: state => state.isHotspotPanelOpened
            },
            actions: {
                closeNavMenu,
                closeNavMenuDelay
            }
        },

        methods: {
            closeNavPanel: function () {
                this.closeNavMenu()
                this.closeNavMenuDelay()
            },
            hasRouteName: function (partial) {
                return (this.$route.name === partial)
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/sass/global';

    $navigation-backshape-timing: 0.5s;

    .navigation-panel {
        position: fixed;
        top: 0;
        left: -9999px;
        z-index: 5;
        height: 100%;
        counter-reset: itemnumber;
        @include gridle(no-gutter);
        @include gridle_grid(10);

        .items {
            @include alignVertical();
            opacity: 0;
        }

        ul, li {
            @include unstyleList();
        }

        ul {
            padding-top: 2.25rem;
        }

        li {
            position: relative;
            opacity: 0;
            transform: translateY(2rem);
            padding-left: 3rem;
            margin: 1.75rem 0;

            @include gridle_state(short) {
                margin: 1.75rem 0 !important;
            }

            @include gridle_state(medium) {
                padding-left: 5rem;
                margin: 2rem 0;
            }

            @include gridle_state(large) {
                padding-left: 10rem;
                margin: 2.25rem 0;
            }

            @include gridle_state(xxlarge) {
                padding-left: 10rem;
                margin: 2.55rem 0;
            }

            a {
                @include headingsStyle();
                transition: color 0.3s ease-out;
                font-size: 1.75rem;
                color: $dark-black--fade;
                counter-increment: itemnumber;

                @include gridle_state(medium) {
                    font-size: 2.5rem;
                }

                @include gridle_state(large) {
                    font-size: 2.8rem;
                }

                @include gridle_state(medium_max) {
                    .hide-for-mobile {
                        display: none;
                    }
                }

                &::before, &::after {
                    transition: all 0.3s ease-out;
                    display: none;
                    position: absolute;
                    top: 50%;
                    opacity: 0;
                    transform: translateX(-2rem) translateY(-50%);

                    @include gridle_state(large) {
                        display: block;
                    }
                }

                &::before {
                    content: ' ';
                    height: 2px;
                    background-color: $dark-black;
                    width: 1.5rem;
                    left: 0;
                }

                &::after {
                    @include headingsStyle();
                    font-size: 1.1rem;
                    content: '0' counter(itemnumber);
                    left: 4.5rem;
                }

                &.v-link-active, &.v-link-active-parent, &:hover, &:focus {
                    color: $dark-black;

                    &::before, &::after {
                        transform: translateX(0) translateY(-50%);
                        opacity: 1;
                    }

                    &::before {
                        width: 3.5rem;
                    }
                }
            }
        }
    }

    // display anim
    .navigation-opened {
        .navigation-panel {
            left: 0;

            .items {
                opacity: 1;
            }
        }
    }

    // sliding anim
    .navigation-opened .navigation-panel .items ul li {
        transition: all 0.6s ease-out;
        transform: translateY(0);
        opacity: 1;

        @for $i from 1 through 6 {
            &:nth-child(#{$i}) {
                transition-delay: 0.3s + 0.2s * $i;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// NavigationPanel.vue?4d95ae9e